var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "ripple",
              rawName: "v-ripple.400",
              value: "rgba(113, 102, 240, 0.15)",
              expression: "'rgba(113, 102, 240, 0.15)'",
              modifiers: { "400": true }
            },
            {
              name: "b-modal",
              rawName: "v-b-modal.modal-history",
              modifiers: { "modal-history": true }
            }
          ],
          staticClass: "waves-effect",
          attrs: { variant: "outline-primary" },
          on: { click: _vm.getListHistory }
        },
        [_vm._v(" " + _vm._s(_vm.$t("form_history_handling")) + " ")]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-history",
            "cancel-variant": "outline-secondary",
            "hide-footer": "true",
            scrollable: "",
            size: "xl",
            title: "Histórico de tratamento"
          }
        },
        [
          _c("b-table", {
            attrs: {
              hover: "",
              "caption-top": "",
              small: "",
              responsive: "sm",
              items: _vm.listItems,
              fields: _vm.fieldsTable
            },
            scopedSlots: _vm._u([
              {
                key: "cell(status)",
                fn: function(data) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._.get(
                            data.item.status,
                            "label",
                            data.item.status_str
                          )
                        ) +
                        " "
                    )
                  ]
                }
              },
              {
                key: "cell(user)",
                fn: function(data) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          data.item.user != null ? data.item.user.name : ""
                        ) +
                        " "
                    )
                  ]
                }
              },
              {
                key: "cell(public_access)",
                fn: function(ref) {
                  var public_access = ref.item.public_access
                  return [
                    _vm._v(
                      " " + _vm._s(public_access == 1 ? "Sim" : "Não") + " "
                    )
                  ]
                }
              },
              {
                key: "cell(description)",
                fn: function(ref) {
                  var description = ref.item.description
                  return [
                    _c("span", {
                      directives: [
                        {
                          name: "html-safe",
                          rawName: "v-html-safe",
                          value: description,
                          expression: "description"
                        }
                      ],
                      staticClass:
                        "break-all whitespace-pre-wrap whitespace-pre-lin simple-editor simple-content"
                    })
                  ]
                }
              },
              {
                key: "cell(forwarding_description)",
                fn: function(ref) {
                  var forwarding_description = ref.item.forwarding_description
                  return [
                    _c("span", {
                      directives: [
                        {
                          name: "html-safe",
                          rawName: "v-html-safe",
                          value: forwarding_description,
                          expression: "forwarding_description"
                        }
                      ],
                      staticClass:
                        "break-all whitespace-pre-wrap whitespace-pre-lin simple-editor simple-content"
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }